import React from 'react'
import i18n from 'i18next'
import StyledText from '#components/a/StyledText'

export default class NotificationsEmpty extends React.Component {
  render() {
    const text = i18n.t('notification_text_no_notifications')
    return <StyledText text={text} modifier="notifications-empty" />
  }
}

NotificationsEmpty.propTypes = {}
